import { ApolloClient } from "apollo-client"
import { InMemoryCache } from "apollo-cache-inmemory"
import { HttpLink } from "apollo-link-http"
import { ApolloLink, from } from "apollo-link"
import fetch from "unfetch"
import {
  API_URL,
  APP_ID,
  // COMPANY_ID, 
  PROFILE_API_URL
} from "./constants"
// import { inBrowser } from "../utils/utils"
import { getDeviceId, inBrowser, decodeUserToken } from "@omnichannel/ace-b2b-elements"
// import decodeUserToken from "./decodeUserToken"
import { getCompanyId } from '../utils/utils'

let deviceId = undefined
if (inBrowser) {
  getDeviceId().then(result => {
    deviceId = result
  })
}

let userInfo = null
const accessToken = inBrowser ? localStorage.getItem("access-token") : ""
if (accessToken) {
  userInfo = decodeUserToken(accessToken)
}

const branch = JSON.parse(
  (inBrowser && localStorage.getItem("ace_app_branch")) || "{}"
)
let branchId = branch._id

const appMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => {
    headers = {
      ...headers,
      appid: APP_ID,
      companyId: getComapnyId(),
      deviceId,
      Token: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${accessToken}`,
      user: userInfo ? userInfo._id : "",
      ...(branchId ? { branchId } : {}),
    }
    return { headers }
  })
  return forward(operation)
})

const httpLink = new HttpLink({
  uri: PROFILE_API_URL ? PROFILE_API_URL : `${API_URL}/profile/graphql`,
  fetch,
})

const estoreClient = new ApolloClient({
  cache: inBrowser
    ? new InMemoryCache().restore(window.__APOLLO_STATE__)
    : new InMemoryCache(),
  link: from([appMiddleware, httpLink]),
})

export default estoreClient
